
import { NavLink, useParams } from "react-router";

import { useTypeFraisByIdQuery } from "../../stores/OkOkStore";
import TypeFraisEditForm from "../../components/TypeFrais/TypeFraisEditForm";
import { useTrads } from "../../contexts/trads/useTrads";

function TypeFraisEdit(){
    const params = useParams();
    const {translate}=useTrads();
    const { data:typefrais, error, isLoading } = useTypeFraisByIdQuery(params.id??"0");

    return (

        error ? (
            <span>{translate('page_load_error')}</span>
        ) : isLoading ? (
            <span>{translate('page_loading')}</span>
        ) : typefrais ? (
            <div>
                <nav>
                    <ul  className="nav nav-tabs">
                        <li className="nav-item">
                            <NavLink className="nav-link" to={`/type_frais/${params.id??"0"}/edit`}>
                                {translate('btn_edit')}
                            </NavLink>
                        </li>
                    </ul>
                </nav>

                <TypeFraisEditForm  typeFraisParam={typefrais} ></TypeFraisEditForm>

            </div>

        ):null
    );
}
export default TypeFraisEdit;